var _defs, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAtendimento(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Agrupar_1",
    "data-name": "Agrupar 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke: #050007;\n        stroke-linecap: round;\n        stroke-width: 1px;\n        stroke-dasharray: 0.001 2;\n        fill-rule: evenodd;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Elipse_1",
    "data-name": "Elipse 1",
    className: "cls-1",
    d: "M329.5,1A46.5,46.5,0,1,1,283,47.5,46.5,46.5,0,0,1,329.5,1ZM259,187s-10.367-92,70-92c0,0,70-6.5,70,92H259Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Ret\\xE2ngulo_3",
    "data-name": "Ret\\xE2ngulo 3",
    className: "cls-1",
    d: "M12,0H200a10,10,0,0,1,10,10V153a10,10,0,0,1-10,10H12A10,10,0,0,1,2,153V10A10,10,0,0,1,12,0ZM210,114l61-32L210,52v62ZM47,70H71V94H47V70Zm46,0h24V94H93V70Zm47,0h24V94H140V70Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Elipse_1_copiar",
    "data-name": "Elipse 1 copiar",
    className: "cls-1",
    d: "M71.5,214A46.5,46.5,0,1,1,25,260.5,46.5,46.5,0,0,1,71.5,214ZM142,400s10.367-92-70-92c0,0-70-6.5-70,92H142Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Ret\\xE2ngulo_3_copiar",
    "data-name": "Ret\\xE2ngulo 3 copiar",
    className: "cls-1",
    d: "M201,236H389a10,10,0,0,1,10,10V389a10,10,0,0,1-10,10H201a10,10,0,0,1-10-10V246A10,10,0,0,1,201,236ZM191,350l-61-32,61-30v62Zm139-44h24v24H330V306Zm-46,0h24v24H284V306Zm-47,0h24v24H237V306Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtendimento);
export default __webpack_public_path__ + "static/media/atendimento.d8c9c099512bd6273b8a03fb684b6491.svg";
export { ForwardRef as ReactComponent };